import { appData, aboutData } from '@/mocks/homeMangaData';

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 bg-background-50/20 rounded-full text-sm font-medium text-background-50 mb-4">
                移动端专属体验
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-2">{appData.title}</h2>
              <p className="text-lg md:text-xl font-heading text-accent-200 mb-4">{appData.subtitle}</p>
              <p className="text-sm md:text-base text-background-50/85 leading-relaxed max-w-lg mb-6">
                {appData.desc}
              </p>
              <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-6">
                {appData.features.map((feat) => (
                  <span key={feat} className="px-3 py-1.5 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full text-sm text-background-50">
                    {feat}
                  </span>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                <button className="px-6 py-3 bg-background-50 hover:bg-background-100 text-primary-600 font-semibold rounded-lg transition-all text-sm whitespace-nowrap cursor-pointer">
                  <i className="ri-apple-fill mr-1.5"></i>App Store
                </button>
                <button className="px-6 py-3 bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 font-medium rounded-lg transition-all text-sm whitespace-nowrap cursor-pointer">
                  <i className="ri-android-fill mr-1.5"></i>Google Play
                </button>
              </div>
            </div>
            <div className="flex-shrink-0 w-48 md:w-56 lg:w-64">
              <img
                src={appData.image}
                alt="咻咻漫画移动端APP"
                className="w-full h-auto object-contain"
                width="300"
                height="600"
                onError={(e) => {
                  const t = e.currentTarget;
                  t.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-shrink-0 w-full lg:w-[420px]">
            <img
              src={aboutData.image}
              alt="咻咻漫画 - 关于我们"
              className="w-full h-56 md:h-64 lg:h-72 object-cover object-top rounded-xl"
              width="800"
              height="500"
              onError={(e) => {
                const t = e.currentTarget;
                t.style.display = 'none';
                (t.parentElement as HTMLElement).style.minHeight = '0';
              }}
            />
          </div>
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">{aboutData.title}</h2>
            <div className="space-y-4 mb-8">
              {aboutData.paragraphs.map((p, i) => (
                <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">{p}</p>
              ))}
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="bg-background-100 rounded-xl p-4 text-center border border-background-200/60">
                  <span className="block text-xl md:text-2xl font-heading font-bold text-primary-600 mb-1">{stat.value}</span>
                  <span className="text-xs text-foreground-500">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function AppAboutSection() {
  return (
    <>
      <AppSection />
      <AboutSection />
    </>
  );
}